export default __webpack_public_path__ + "static/media/2147.e26754fe.png";